import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hr",
  "use": "icon-hr-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-hr\"><path d=\"M5 13a1 1 0 010-2h14a1 1 0 010 2H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol